import React, { useCallback, useState } from 'react'

import { Dialog } from '@inno-ui/dialog'
import {
  ChevronDownIcon,
  ChevronUpIcon,
  IconSizes,
  IconWeight
} from '@inno-ui/icons'
import cn from 'clsx'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLanguageSelector } from 'shared/hooks'

import styles from './PublicRouteLanguageSelector.module.scss'

export const PublicRouteLanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const handleToggle = useCallback(() => setIsOpen(v => !v), [])

  const { changeLanguage, currentLanguageOption, languageOptions } =
    useLanguageSelector()

  const handleLanguageChange = useCallback(
    (newLang: string) => {
      changeLanguage(newLang)
      setIsOpen(false)

      // replace language prefix in url
      const newPath = location.pathname.replace(
        /^\/[^/]+\/public/,
        `/${newLang}/public`
      )

      navigate(
        {
          pathname: newPath,
          search: location.search,
          hash: location.hash
        },
        { replace: true }
      )

      window.location.reload()
    },
    [changeLanguage, navigate, location]
  )

  const Icon = isOpen ? ChevronUpIcon : ChevronDownIcon

  const trigger = (
    <button
      type='button'
      className={cn(styles.publicRouteLanguageSelector, {
        [styles.isOpen]: isOpen
      })}
      onClick={handleToggle}
      aria-haspopup='dialog'
      aria-expanded={isOpen}
      aria-label='Select language'
    >
      <img
        src={currentLanguageOption.icon}
        alt={currentLanguageOption.label}
        className={styles.flag}
      />
      <span className={styles.selectedLanguage}>
        {currentLanguageOption.value}
      </span>
      <Icon
        size={IconSizes.Size14}
        color='var(--white)'
        weight={IconWeight.Bold}
      />
    </button>
  )

  const dropdown = (
    <div className={styles.dropdown}>
      {languageOptions.map(lang => (
        <button
          key={lang.value}
          onClick={() => {
            handleLanguageChange(lang.value)
          }}
        >
          {lang.label}
        </button>
      ))}
    </div>
  )

  return (
    <Dialog
      isOpen={isOpen}
      body={dropdown}
      setIsOpen={setIsOpen}
      onClose={() => setIsOpen(false)}
      triggerAutoZIndex
      hideHeader
      minWidth='120px'
    >
      {trigger}
    </Dialog>
  )
}
